/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
//@ts-ignore
import { EditorState, convertToRaw, ContentState } from 'draft-js';
//@ts-ignore
import { Editor } from 'react-draft-wysiwyg';
//@ts-ignore
import draftToHtml from 'draftjs-to-html';
//@ts-ignore
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import * as MS from '../../styles';
import { S } from './styles';

export interface IHtmlEditorProps {
    id: string;
    fontScale?: number;

    label?: string;
    labelColor?: string;
    errorText?: string;
    value?: string;
    required?: boolean;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
}

const getEditorState = (value: string) => {
    const contentBlock = htmlToDraft(value);
    if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks
        );
        return EditorState.createWithContent(contentState);
    }
};

export const HtmlEditor = ({
    id,
    fontScale,

    label,
    labelColor,
    errorText,
    value,
    required,
    onCompChange,
    hasError,
}: IHtmlEditorProps) => {
    const [editorState, setEditorState] = React.useState(
        value ? getEditorState(value) : () => EditorState.createEmpty()
    );

    const onChange = (id: string, e: any) => {
        setEditorState(e);
        let html = draftToHtml(convertToRaw(e.getCurrentContent()));
        if (html) {
            html = html.replace(/(\r\n|\n|\r)/gm, '');
        }
        onCompChange && onCompChange(id, html);
    };
    const _renderLabelIf = () => {
        if (label) {
            return (
                <MS.FormLabel color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </MS.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <MS.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </MS.FeedbackOtherLabel>
            );
        }
        return null;
    };

    return (
        <>
            <Form.Group id={id} className=" formgroup">
                {_renderLabelIf()}
                <InputGroup>
                    <div style={S.containerStyle}>
                        <Editor
                            editorState={editorState}
                            wrapperClassName="wrapper-class"
                            editorClassName="editor-class"
                            toolbarClassName="toolbar-class"
                            onEditorStateChange={onChange.bind(null, id)}
                        />
                    </div>
                    <InputGroup>{_renderErrorTextIf()}</InputGroup>
                </InputGroup>
            </Form.Group>
        </>
    );
};

HtmlEditor.defaultProps = {
    required: false,
    hasError: false,
};
